import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { NavigateFunction } from "react-router-dom";
import { IconEdit01, IconTrash01 } from "@pentabd/icons";
import { PackageType } from "@type/procurements/package";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  navigate: NavigateFunction,
  roles: any,
  openConfirmationModel: (itemName: string, id: string | number) => void,
  getAccess: (roles: string[], roleType: string) => boolean,
) => {
  return [
    {
      id: 1,
      key: "title",
      name: t("APP_DETAILS.TABLE.COLUMN.NAME"),
      render: (title: string) => <Text color="subtitle1">{title}</Text>,
    },
    {
      id: 2,
      key: "packageRefNo",
      name: t("APP_DETAILS.TABLE.COLUMN.PACKAGE_REF_NO"),
      render: (packageRefNo: string) => (
        <Text color="subtitle1">{packageRefNo}</Text>
      ),
    },
    {
      id: 3,
      key: "allocatedBudget",
      name: t("APP_DETAILS.TABLE.COLUMN.TOTAL_BUDGET"),
      render: (allocatedBudget: number) => (
        <Text color="subtitle1">{allocatedBudget}</Text>
      ),
    },
    {
      id: 4,
      key: "id",
      name: "",
      render: (id: string | number, row: PackageType) => {
        const commonStyles = {
          cursor: "pointer",
        };
        return (
          <div className="d-flex gap-3 align-items-center">
            <div
              onClick={() => {
                navigate(`${id}`);
              }}
              style={commonStyles}
            >
              <IconEdit01 size={20} fill="subtitle1" />
            </div>
            {getAccess(roles, "PROCUREMENT_HR") && (
              <div
                onClick={() => openConfirmationModel(row?.title, id)}
                style={commonStyles}
              >
                <IconTrash01 size={20} fill="danger" />
              </div>
            )}
          </div>
        );
      },
    },
  ];
};
